import user from "@/api/user";

const state = {
    users: []
};

const getters = {
    users: state => {
        return state.users;
    }
};

const actions = {
    get({ commit }) {
        return user
            .get()
            .then(response => {
                if (response.status === 200) {
                    commit("SET_USERS", response.data.data);
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    },

    store({ commit }, data) {
        return user
            .store(data)
            .then(response => {
                if (response.status === 200) {
                    commit("ADD_USER", response.data.data);
                }
                return response;
            })
            .catch(error => {
                console.log("error " + error);
                return error;
            });
    }
};

const mutations = {
    SET_USERS(state, value) {
        state.users = value;
    },
    ADD_USER(state, value) {
        state.users.push(value);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
